import * as React from "react";

import { ITag } from "@bps/fluent-ui";

import { ConvertToSinglePickerProps } from "./ExtendedPicker.types.ts";
import { extendToSingleTagPicker } from "./extendToSingleTagPicker.tsx";
import {
  StaticMultiTagPicker,
  StaticMultiTagPickerProps
} from "./MultiTagPicker.tsx";

export type StaticPickerProps = ConvertToSinglePickerProps<
  StaticMultiTagPickerProps,
  ITag
>;

/**
 * A single selection StaticTagPicker.
 * See StaticTagPicker for more information.
 * @param props
 */
export const StaticPicker = extendToSingleTagPicker<
  StaticMultiTagPickerProps,
  ITag
>(StaticMultiTagPicker) as React.FunctionComponent<StaticPickerProps>;
